import * as types from './actionTypes';

export const getCheckPriceDocs = (orderType, params) => ({type: types.ORDER_CHECK_PRICE_GET, orderType, params });

export const getCheckPriceDocSuccess = (payload) => ({type: types.ORDER_CHECK_PRICE_SUCCESS, payload})

export const getCheckPriceDocFail = (error) => ({ type: types.ORDER_CHECK_PRICE_FAIL, error });
